import { EmailTemplateBasicsItemArray } from '../../domain/email.template.basics.item';
import { EmailFromItemArray } from '../../domain/email.from.item';

export interface ITemplatesAndFromResponse {
 Templates: EmailTemplateBasicsItemArray;
 FromItems: EmailFromItemArray;
}

export class TemplatesAndFromResponse implements ITemplatesAndFromResponse {
    Templates: EmailTemplateBasicsItemArray;
    FromItems: EmailFromItemArray;
}

export class TemplatesAndFromResponseArray extends Array<TemplatesAndFromResponse> {

    constructor(...items: TemplatesAndFromResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, TemplatesAndFromResponseArray.prototype);
    }

}

